import { useProfissionalSelect } from "./use-profissional-select";
import { ProfissionalSelectView } from "./view-profissional-select";
import type { ProfissionalSelectProps } from "./types-profissional-select";

export function ProfissionalSelect(props: ProfissionalSelectProps) {
  const vm = useProfissionalSelect(props);
  return <ProfissionalSelectView vm={vm} />;
}

export type * from "./types-profissional-select";
